import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { LodgingHeadingViewModel } from 'models';

import { UitkHeading } from 'uitk-react-text';

import { ResultProps } from 'components/search/result';

export interface ListTitleProps extends ResultProps {
  model: LodgingHeadingViewModel;
}

export const ListTitle: React.FC<ListTitleProps> = React.memo(({ model: { value, size, level }, className }) => (
  <ErrorBoundary label="hotel.search.listingTitle">
    <li className={`uitk-cell ${className}`}>
      <div className="all-t-padding-three">
        <UitkHeading level={level} size={size}>
          {value}
        </UitkHeading>
      </div>
    </li>
  </ErrorBoundary>
));

ListTitle.displayName = 'ListTitle';
